import Color from 'color';
import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class KindColorIcon extends Field {
  static subqueriesForModel() {
    return { workflowKind: ['iconName', 'color'] };
  }

  get title() {
    return 'Type icon with color';
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'fa-solid fa-bug', color: '#C9250E' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.workflowKind) {
      return {
        icon: {
          name: `fa-solid ${record.workflowKind.iconName}`,
          color: Color(record.workflowKind.color).hex(),
        },
      };
    }

    return {};
  }
}
